import React from 'react'
import PropTypes from 'prop-types'

import { Player } from 'video-react'

import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'

import ExternalLink from '@material-ui/icons/Launch'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

require('./../../../../assets/styles/video.css')

const styles = {
  cardstyle: {
    padding: 5,
  },
  figcaption: {
    padding: 5
  },
  icon: {
    fontSize: 16,
  },
};

function VideoCard(props) {
  const { classes } = props;
  return (
    <Grid container spacing={10}>
      <Grid item xs={12}>
        <Paper className={classes.cardstyle}>
          <Player>
            <source src="https://wiki.instar.com/videos/IN_LAN_500_Powerline_Adapter.mp4" />
          </Player>
          <div className={classes.figcaption}>
            <p>Der IN-Lan 500 Powerline Adapter ist ideal zur Erstellung eines Netzwerkes über das Stromnetz, einfach einstecken und fertig. Ihre Vorteile:</p>
            <ul>
              <li>Nutzen Sie bestehende Stromleitungen um mit IN-LAN ein Netzwerk zu realisieren</li>
              <li>Sehr einfache Plug n Play Technologie. Einfach in die Steckdose stecken und fertig</li>
              <li>Super schneller Datentransfer bis zu 500Mbps</li>
              <li>Erweitern Sie Ihr Netzwerk um so z.B. Ihre IP Kamera oder andere Netzwerkgeräte    zu verkabeln ohne Netzwerkkabel zu verlegen</li>
              <li>Eine sehr detallierte Anleitung mach Ihnen die Installation sehr leicht</li>
            </ul>
            <p>Auf <OutboundLink href="https://www.youtube.com/watch?v=q3yBixX9UmI" target="_blank" rel="noopener noreferrer">Youtube ansehen <ExternalLink className={classes.icon} /></OutboundLink></p>
          </div>
        </Paper>
      </Grid>
    </Grid>
  );
}

VideoCard.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(VideoCard)